/**
 * @author Karthik <karthik.x@314ecorp.com>
 * @description config
 */

/**
 * @author Karthik <karthik.x@314ecorp.com>
 * @description config
 */

import Environment from 'utils/Environment';
import integration from './config.integration';
import production from './config.production';

const config = Environment.isIntegration() ? integration : production;
export default config;
